module.exports = __webpack_public_path__ + "img/6.b233c052.png";